
import { useEffect, useRef, useState } from "react"
import "./fileModalLight.css"
import "./fileModalDark.css"
import { useSelector } from "react-redux";
export default function FileModal({ item }) {
    const showFileModalRef = useRef(null);
    const [indexFileModal, setindexFileModal] = useState(0);
    const getDarkModoe = useSelector(darkModes => darkModes);

    const handleShowModal = (e) => {
        showFileModalRef.current.style.display = "flex"
        setindexFileModal(e)
    }
    const handleClose = () => {
        showFileModalRef.current.style.display = "none"
    }



    const handleDownload = () => {
        fetch("http://localhost:3000/" + item.files[indexFileModal].originalname)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.arrayBuffer();
            })
            .then(buffer => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                // Убедитесь, что item.files[indexFileModal] определено и имеет свойство originalname
                const fileName = item.files[indexFileModal]?.originalname || 'file.png'; // По умолчанию устанавливаем имя файла 'file.png'
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(error => {
                console.error(error);
                throw new Error("Ошибка при скачивании файла fileModal.jsx");
            });

    };


    return (
        <>
            <div  className={getDarkModoe.ToggleDarkModeReducer.chekced ? "fileFlexContDark" : "fileFlexCont"}>
                {
                    item?.files?.map((item, index) => {
                            console.log(item.originalname);
                        if (item?.mimetype == "image/png") {

                            return (
                                <div className="fileCont" onClick={() => { handleShowModal(index) }} key={index}>
                                    <div>
                                        <img src={item.imageUrl} alt="" />
                                        <button>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M17.9431 15.8673H17.2058L16.9445 15.6153C18.0645 14.3087 18.6431 12.526 18.3258 10.6313C17.8871 8.03668 15.7218 5.96468 13.1085 5.64735C9.16046 5.16201 5.8378 8.48468 6.32313 12.4327C6.64046 15.046 8.71246 17.2113 11.3071 17.65C13.2018 17.9673 14.9845 17.3887 16.2911 16.2687L16.5431 16.53V17.2673L20.5098 21.234C20.8925 21.6167 21.5178 21.6167 21.9005 21.234C22.2831 20.8513 22.2831 20.226 21.9005 19.8433L17.9431 15.8673ZM12.3431 15.8673C10.0191 15.8673 8.14313 13.9913 8.14313 11.6673C8.14313 9.34335 10.0191 7.46735 12.3431 7.46735C14.6671 7.46735 16.5431 9.34335 16.5431 11.6673C16.5431 13.9913 14.6671 15.8673 12.3431 15.8673Z" fill="white" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )
                        } else if (item?.mimetype == "video/mp4") {

                            return (
                                <div className="fileCont" onClick={() => { handleShowModal(index) }} key={index}>
                                    <div>
                                        <video src={item.imageUrl} alt="" autoPlay muted />
                                        <button>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M17.9431 15.8673H17.2058L16.9445 15.6153C18.0645 14.3087 18.6431 12.526 18.3258 10.6313C17.8871 8.03668 15.7218 5.96468 13.1085 5.64735C9.16046 5.16201 5.8378 8.48468 6.32313 12.4327C6.64046 15.046 8.71246 17.2113 11.3071 17.65C13.2018 17.9673 14.9845 17.3887 16.2911 16.2687L16.5431 16.53V17.2673L20.5098 21.234C20.8925 21.6167 21.5178 21.6167 21.9005 21.234C22.2831 20.8513 22.2831 20.226 21.9005 19.8433L17.9431 15.8673ZM12.3431 15.8673C10.0191 15.8673 8.14313 13.9913 8.14313 11.6673C8.14313 9.34335 10.0191 7.46735 12.3431 7.46735C14.6671 7.46735 16.5431 9.34335 16.5431 11.6673C16.5431 13.9913 14.6671 15.8673 12.3431 15.8673Z" fill="white" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div className="otherFileCont" onClick={() => { handleShowModal(index) }} key={index}>
                                    <div>
                                        <div>
                                            <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                <path d="M5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H9C9.41421 10.25 9.75 10.5858 9.75 11C9.75 11.4142 9.41421 11.75 9 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11Z" fill="#3B79F6" />
                                                <path d="M5.25 15C5.25 14.5858 5.58579 14.25 6 14.25H14C14.4142 14.25 14.75 14.5858 14.75 15C14.75 15.4142 14.4142 15.75 14 15.75H6C5.58579 15.75 5.25 15.4142 5.25 15Z" fill="#3B79F6" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0324 0.333724C15.107 0.418172 16.0049 0.591725 16.7782 0.981678C16.9892 1.08809 17.1892 1.20967 17.3798 1.34815C17.8679 1.70281 18.2972 2.13209 18.6518 2.62023C19.2377 3.42656 19.5 4.37094 19.6263 5.53648C19.75 6.67861 19.75 8.1182 19.75 9.95473V12.0453C19.75 13.8818 19.75 15.3214 19.6263 16.4635C19.5 17.6291 19.2377 18.5734 18.6518 19.3798C18.2972 19.8679 17.8679 20.2972 17.3798 20.6518C16.5734 21.2377 15.6291 21.5 14.4635 21.6263C13.3214 21.75 11.8818 21.75 10.0453 21.75H9.95473C8.1182 21.75 6.67861 21.75 5.53648 21.6263C4.37094 21.5 3.42656 21.2377 2.62024 20.6518C2.13209 20.2972 1.70281 19.8679 1.34815 19.3798C0.762324 18.5734 0.500006 17.6291 0.373728 16.4635C0.249985 15.3214 0.249992 13.8818 0.25 12.0452V9.95475C0.249992 8.11821 0.249985 6.67861 0.373728 5.53648C0.500006 4.37094 0.762324 3.42656 1.34815 2.62023C1.70281 2.13209 2.13209 1.70281 2.62024 1.34815C2.98789 1.08103 3.38699 0.879231 3.82759 0.727205C4.55633 0.47576 5.39671 0.361672 6.38484 0.305723C7.36901 0.249998 8.55244 0.249999 9.97961 0.25H10.0305C11.6555 0.249997 12.9669 0.249994 14.0324 0.333724ZM13.9149 1.82911C12.9149 1.75053 11.6617 1.75 10 1.75C8.54848 1.75 7.40668 1.75027 6.46964 1.80332C6.14312 1.82181 5.8479 1.84647 5.57917 1.87856C6.41092 2.70052 7.07917 3.33457 7.67572 3.81202C8.47813 4.45425 9.08459 4.75721 9.69912 4.85454C10.1396 4.92431 10.5883 4.92431 11.0288 4.85454C11.6262 4.75993 12.2161 4.47095 12.9856 3.8649C13.5734 3.40202 14.2309 2.78324 15.0492 1.97683C14.7236 1.91158 14.3502 1.86333 13.9149 1.82911ZM16.5509 2.60065C15.5226 3.62405 14.6769 4.44231 13.9137 5.04333C13.0379 5.73301 12.2116 6.1859 11.2635 6.33608C10.6675 6.43047 10.0604 6.43047 9.46447 6.33608C8.48904 6.18158 7.64243 5.70666 6.73842 4.98311C5.92896 4.33525 5.02087 3.44359 3.8968 2.32123C3.7556 2.39247 3.62499 2.47225 3.50191 2.56168C3.14111 2.82382 2.82382 3.14111 2.56168 3.50191C2.19259 4.00992 1.97745 4.66013 1.865 5.69804C1.75103 6.74999 1.75 8.10843 1.75 10V12C1.75 13.8916 1.75103 15.25 1.865 16.302C1.97745 17.3399 2.19259 17.9901 2.56168 18.4981C2.82382 18.8589 3.14111 19.1762 3.50191 19.4383C4.00992 19.8074 4.66013 20.0225 5.69805 20.135C6.74999 20.249 8.10843 20.25 10 20.25C11.8916 20.25 13.25 20.249 14.302 20.135C15.3399 20.0225 15.9901 19.8074 16.4981 19.4383C16.8589 19.1762 17.1762 18.8589 17.4383 18.4981C17.8074 17.9901 18.0225 17.3399 18.135 16.302C18.249 15.25 18.25 13.8916 18.25 12V10C18.25 8.10843 18.249 6.74999 18.135 5.69804C18.0225 4.66013 17.8074 4.00992 17.4383 3.50191C17.189 3.15881 16.8899 2.85505 16.5509 2.60065Z" fill="#3B79F6" />
                                            </svg>
                                            </div>
                                            <div>
                                                <p>{item.originalname}</p>
                                                <p>{(item.size / 1024).toFixed(2) + ' KB'}</p>
                                            </div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                            <path d="M1.9483 3.96898C1.65541 3.67608 1.18053 3.67608 0.887639 3.96898C0.594745 4.26187 0.594745 4.73674 0.887639 5.02963L3.60999 7.75199C3.90288 8.04488 4.37776 8.04488 4.67065 7.75199L11.115 1.30767C11.4079 1.01478 11.4079 0.539907 11.115 0.247014C10.8221 -0.0458796 10.3472 -0.0458796 10.0543 0.247014L4.14032 6.161L1.9483 3.96898Z" fill="white" />
                                        </svg>
                                    </div>
                                </div>
                            )
                        }

                    })
                }
            </div>
            {/* modal */}
            <div className="modalForChatFileLight" ref={showFileModalRef}>
                <div className="modalForChatFile-content">
                    <div className="modalForChatFile-header">

                        <h2>{item?.files[indexFileModal]?.originalname}</h2>


                        <div className="btnCont">
                            <div>
                                <div onClick={handleDownload}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
                                        <path d="M1.5 17H13.5" stroke="#6A7180" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.5 13L4 9.5M7.5 1V13V1ZM7.5 13L11 9.5L7.5 13Z" stroke="#6A7180" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div onClick={handleClose}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M1 1L15 15M1.00003 15L8.00003 8L15 1" stroke="#6A7180" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modalForChatFile-body">

                        {item?.files[indexFileModal]?.mimetype == "image/png" &&
                            <img src={item?.files[indexFileModal]?.imageUrl} alt="" />
                        }
                        {item?.files[indexFileModal]?.mimetype == "video/mp4" &&
                            <video src={item?.files[indexFileModal]?.imageUrl} alt="" autoPlay controls />
                        }

                    </div>

                </div>

            </div>

        </>
    )
}